import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  FollowUpNecessityJudgmentResultApi,
  FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest,
  GetFollowUpNecessityJudgmentResult200Response,
  FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest,
} from '@/api/openapi';

export class FollowUpNecessityJudgmentResultApiService extends ApiService {
  api = new FollowUpNecessityJudgmentResultApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getFollowUpNecessityJudgmentResult(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest>,
  ): Promise<AxiosResponse<GetFollowUpNecessityJudgmentResult200Response>> {
    return this.checkResponse<GetFollowUpNecessityJudgmentResult200Response>(
      this.api.getFollowUpNecessityJudgmentResult(request, options),
      errorHandlers,
    );
  }

  async postJudgeFollowUpNecessity({
    request,
    options,
    errorHandlers,
  }: ApiArguments<FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest>) {
    return this.checkResponse<void>(
      this.api.postJudgeFollowUpNecessity(request, options),
      errorHandlers,
    );
  }
}
